import type { SVGProps } from "react";
import * as React from "react";
const SvgProductboard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 -44 256 256"
    width="1em"
    height="1em"
    {...props}
  >
    <path fill="#FF2638" d="m85.327 83.997 85.327 83.996H0z" />
    <path fill="#FFC600" d="m0 0 85.327 83.997L170.654 0z" />
    <path
      fill="#0079F2"
      d="m85.34 83.997 85.328 83.996 85.327-83.996L170.668 0z"
    />
  </svg>
);
export default SvgProductboard;
